import "../plan.scss"

import { Button, Collapsible, Text } from "@shopify/polaris"
import classNames from "classnames"
import { Observer, observer } from "mobx-react"
import { MinusIcon, PlusIcon } from "polaris-enhance"
import { useMemo, useState } from "react"

import { Switch } from "@/components"
import stores from "@/stores"
import { PlanEnum } from "@/stores/Plan/type"

const AllPlanListComp = () => {
  const { PlanStore } = stores
  const { completedPackageList, type, curPlanStep } = PlanStore
  const [showDiff, setShowDiff] = useState(false)
  const [open, setOpen] = useState(false)
  const essInfo = completedPackageList?.filter((item) => item.kind === 2)?.[0]
    ?.priceInfo[type]?.[curPlanStep[PlanEnum.Essential]]
  const proInfo = completedPackageList?.filter((item) => item.kind === 3)?.[0]
    ?.priceInfo[type]?.[curPlanStep[PlanEnum.Professional]]
  const entInfo = completedPackageList?.filter((item) => item.kind === 4)?.[0]
    ?.priceInfo[type]?.[curPlanStep[PlanEnum.Enterprise]]

  const featureList = [
    [
      <div className="flex items-start gap-x-2 h-full">
        <Switch checked={showDiff} onChange={(v) => setShowDiff(v)} />
        <Text variant="bodyMd" as="span" tone="subdued">
          {t("OnlyShowDifferences")}
        </Text>
      </div>,
      <div className="space-y-4 text-center w-full">
        <Text variant="headingMd" as="span">
          {t("Free")}
        </Text>
      </div>,
      <div className="space-y-4 text-center w-full">
        <Text variant="headingMd" as="span">
          {t("Essential")}
        </Text>
      </div>,
      <div className="space-y-4 text-center w-full">
        <Text variant="headingMd" as="span">
          {t("Professional")}
        </Text>
      </div>,
      <div className="space-y-4 text-center w-full">
        <Text variant="headingMd" as="span">
          {t("Enterprise")}
        </Text>
      </div>,
    ],
    [
      <Text variant="bodyMd" as="p" fontWeight="medium">
        {t("Pricing")}
      </Text>,
      <Text variant="bodyMd" as="p" fontWeight="medium">
        $0/{t("month")}
      </Text>,
      <div>
        {essInfo?.actual_price !== essInfo?.origin_price &&
        essInfo?.origin_price ? (
          <span className="mr-1 line-through">${essInfo?.origin_price}</span>
        ) : (
          ""
        )}
        <Text variant="bodyMd" as="p" fontWeight="medium">
          ${essInfo?.actual_price}/{t("month")}
        </Text>
      </div>,
      <div>
        {proInfo?.actual_price !== proInfo?.origin_price &&
        proInfo?.origin_price ? (
          <span className="mr-1 line-through">${proInfo?.origin_price}</span>
        ) : (
          ""
        )}
        <Text variant="bodyMd" as="p" fontWeight="medium">
          ${proInfo?.actual_price}/{t("month")}
        </Text>
      </div>,
      <div>
        {entInfo?.actual_price !== entInfo?.origin_price &&
        entInfo?.origin_price ? (
          <span className="mr-1 line-through">${entInfo?.origin_price}</span>
        ) : (
          ""
        )}
        <Text variant="bodyMd" as="p" fontWeight="medium">
          ${entInfo?.actual_price}/{t("month")}
        </Text>
      </div>,
    ],
  ]
  const list = useMemo(() => {
    return [
      {
        list:
          type === 2
            ? [
                [
                  t("ExtraQuota"),
                  "Unavailable",
                  "Unavailable",
                  "Unavailable",
                  "Unavailable",
                ],
                [
                  t("ReturnProtection"),
                  "Unavailable",
                  "Unavailable",
                  "Unavailable",
                  "Unavailable",
                ],
              ]
            : [
                [
                  t("ExtraQuota"),
                  "Unavailable",
                  "Available",
                  "Available",
                  "Available",
                ],
                [
                  t("ReturnProtection"),
                  "Unavailable",
                  "Available",
                  "Available",
                  "Available",
                ],
              ],
      },
      {
        title: t("ReturnSolution"),
        list: [
          [t("ExchangeItem"), "-", "-", true, true],
          [t("ReplaceItem"), "-", true, true, true],
          [t("RefundToOriginalPaymentMethod"), true, true, true, true],
          [t("RefundToStoreCredit"), "-", "-", true, true],
          [t("RefundToStoreGiftCard"), "-", true, true, true],
          [t("RefundToStoreDiscount"), "-", true, true, true],
          [t("RefundViaManualBankTransfer"), "-", true, true, true],
          [t("RefundViaWise"), "-", "-", true, true],
        ],
      },
      {
        title: t("ReturnRule"),
        list: [
          [t("ShippingFee"), "-", true, true, true],
          [t("RestockingFee"), "-", true, true, true],
          [t("ReturnReward"), "-", true, true, true],
          [t("ReturnWindowSetting"), true, true, true, true],
          [t("ExchangesSetting"), "-", true, true, true],
          [t("BlockRules"), "-", true, true, true],
          [t("ReturnRequestSetting"), true, true, true, true],
          [t("ExchangeOrderStatusSetting"), true, true, true, true],
        ],
      },
      {
        title: t("CarriersIntegrations"),
        list: [
          [t("ParcelwillCarriers"), true, true, true, true],
          [t("ConnectYourOwnCarriers"), "-", "-", true, true],
        ],
      },
      {
        title: t("LocationsPackaging"),
        list: [
          [t("ReturnDocument"), "-", true, true, true],
          [t("CustomReturnLocations"), true, true, true, true],
          [t("CustomReturnPackages"), true, true, true, true],
        ],
      },
      {
        title: t("ReturnShippingMethod"),
        list: [
          [t("ShipOnYourOwn"), true, true, true, true],
          [t("Pickup"), true, true, true, true],
          [t("MerchantProvidedLabel"), true, true, true, true],
          [t("GreenReturns"), "-", true, true, true],
          [t("LabelQrCodeViaParcelWILLCarriers"), "-", true, true, true],
        ],
      },
      {
        title: t("ReturnPage"),
        list: [
          [t("BrandedReturnPage"), true, true, true, true],
          [t("CustomDomain"), true, true, true, true],
          [t("AccountPageReturnsWidget"), true, true, true, true],
          [t("RemoveBranding"), "-", "-", true, true],
          [t("MultiLanguage"), "-", true, true, true],
          [t("Analytics"), true, true, true, true],
        ],
      },
      {
        title: t("ReturnManagement"),
        list: [
          [t("Timeline"), true, true, true, true],
          [t("ReturnsDataExport"), "-", "-", true, true],
        ],
      },
      {
        title: t("Integrations"),
        list: [
          [t("ReturnsWebhooks"), "-", "-", "-", true],
          [t("OrderTrackingIntegration"), "-", "-", true, true],
          [t("WisePaymentsIntegration"), "-", "-", true, true],
        ],
      },
      {
        title: t("Notification"),
        list: [
          [t("CustomSendingDomain"), "-", true, true, true],
          [t("EmailNotifications"), "-", true, true, true],
        ],
      },
      {
        title: t("Support"),
        list: [
          [
            t("LiveChatTime", {
              hours: 24,
              days: 7,
            }),
            true,
            true,
            true,
            true,
          ],
          [t("PrioritySupport"), "-", "-", true, true],
          [t("SuccessManager"), "-", "-", true, true],
        ],
      },
    ]
  }, [type])

  const showList = useMemo(() => {
    if (!showDiff) return list
    // 第一次过滤
    const filterList = list.map((item) => {
      return {
        ...item,
        list: item.list.filter((arr) => {
          const theCheckedArr = arr.slice(1)

          if (typeof theCheckedArr[0] !== "object") {
            return !theCheckedArr.every((item) => item === theCheckedArr[0])
          }
          return true
        }),
      }
    })
    return filterList.filter((item) => {
      return item.list.length > 0
    })
  }, [list, showDiff])

  function renderNodes(nodes, noShadow = false) {
    function getRender(item) {
      if (item === true) {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="20" height="20" rx="10" fill="#fff" />
            <rect x="2" y="2" width="16" height="16" rx="8" fill="#fff" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.8162 6.20701C16.0701 6.47369 16.0597 6.89568 15.793 7.14954L8.08929 14.4829C7.95773 14.6081 7.78078 14.6742 7.59933 14.666C7.41788 14.6577 7.24766 14.5758 7.12803 14.4391L4.16506 11.0545C3.92254 10.7775 3.95052 10.3563 4.22755 10.1138C4.50459 9.87125 4.92577 9.89923 5.16829 10.1763L7.67342 13.0379L14.8737 6.1838C15.1404 5.92994 15.5624 5.94033 15.8162 6.20701Z"
              fill="#298177"
            />
          </svg>
        )
      }
      if (item === "Unavailable") {
        return (
          <Text variant="bodyMd" as="span" tone="subdued">
            {t("Unavailable")}
          </Text>
        )
      }
      if (item === "Available") {
        return (
          <Text variant="bodyMd" as="span" tone="success">
            {t("Available")}
          </Text>
        )
      }
      return item
    }
    return (
      <div
        className={classNames(
          "grid grid-cols-[272px_repeat(4,_1fr)]  items-center",
          {
            "shadow-base": !noShadow,
          },
        )}
      >
        {nodes.map((item, ni) => {
          return (
            <div
              className={classNames("py-4 px-4 h-full min-w-[100px]", {
                "flex justify-center": ni !== 0,
              })}
            >
              {getRender(item)}
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <Observer>
      {() => {
        return (
          <div>
            <div className="flex justify-center items-center gap-2">
              <Button
                onClick={() => setOpen((open) => !open)}
                icon={open ? MinusIcon : PlusIcon}
              >
                {open ? t("CloseFeatures") : t("FullListOfFeature")}
              </Button>
            </div>
            <Collapsible
              open={open}
              id="all-plan"
              transition={{ duration: "0ms", timingFunction: "ease-in-out" }}
            >
              <div className="mb-4 mt-1">
                <Text variant="headingLg" as="h2" fontWeight="medium">
                  {t("AllPlans")}
                </Text>
              </div>
              <div className="overflow-auto lg:overflow-clip ">
                <div
                  className="min-w-[740px] bg-[#fff] rounded-xl"
                  style={{ border: "1px solid #e1e2e3" }}
                >
                  <div
                    className="sticky top-0 bg-white z-30"
                    style={{
                      borderTopLeftRadius: "12px",
                      borderTopRightRadius: "12px",
                    }}
                  >
                    {renderNodes(featureList[0])}
                  </div>
                  {renderNodes(featureList[1])}

                  {showList.map((item, i) => {
                    return (
                      <div>
                        {item.title ? (
                          <div className="px-4 py-4 items-center shadow-base bg-[#FAFBFB]">
                            <Text variant="bodyMd" as="p" fontWeight="medium">
                              {item.title}
                            </Text>
                          </div>
                        ) : null}
                        <div>
                          <Text
                            variant="bodyMd"
                            as="span"
                            fontWeight={!item.title ? "medium" : "regular"}
                          >
                            {item.list.map((nodes, j) =>
                              renderNodes(
                                nodes,
                                i === showList.length - 1 &&
                                  j === item.list.length - 1,
                              ),
                            )}
                          </Text>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </Collapsible>
          </div>
        )
      }}
    </Observer>
  )
}

export const AllPlanList = observer(AllPlanListComp)
